<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>KYC认证审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="未审核" name="0"></el-tab-pane>
        <el-tab-pane label="审核通过" name="1"></el-tab-pane>
        <el-tab-pane label="审核不通过" name="2"></el-tab-pane>
        <el-tab-pane label="黑名单" name="-1"></el-tab-pane>
        <el-tab-pane label="高级认证" name="hight"></el-tab-pane>
      </el-tabs>
      <div class="actions-bar">
        <el-input placeholder="请输入账号ID" clearable v-model="userId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <el-input placeholder="请输入手机号" clearable v-model="tel">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->
        <!-- <el-input placeholder="请输入邮箱号" clearable v-model="email">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->
        <el-input
          placeholder="请输入名字"
          clearable
          v-model="realName"
          v-if="activeTab == 'hight'"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="statusType"
          placeholder="状态"
          clearable
          v-if="activeTab == 'hight'"
        >
          <el-option
            v-for="(item, index) in typeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select v-model="tenantId" placeholder="租户选择" clearable>
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="times"
          type="daterange"
          format="yyyy 年 MM 月 dd 日"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始"
          end-placeholder="结束"
        ></el-date-picker>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <!-- <el-button :href="downloadLink" @click="downloadTemplate" target="_blank" v-if="this.types != 1"
          >导出Excel</el-button> -->
        <a
          @click="exportExcel"
          target="_blank"
          v-if="this.types != 1 && this.authType == 0"
          >导出Excel</a
        >
      </div>
      <audit-list @refresh="refreshList($event)" :types="types"></audit-list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import AuditList from "./components/list";
import { PAGINATION } from "./constants";
import qs from "qs";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "KYC",
  data() {
    return {
      userId: null,
      tel: "",
      email: "",
      times: [],
      types: "",
      tenantId: "",
      tenantList: [],
      authType: "0",
      typeOptions: [
        { label: "全部", value: "" },
        // { label: "黑名单", value: "-1" },
        // { label: "未开始", value: "0" },
        // { label: "审核通过", value: "1" },
        // { label: "审核未通过", value: "2" },
        { label: "认证成功", value: "3" },
        { label: "认证失败", value: "4" },
      ],
      statusType: "",
      realName: "",
    };
  },
  components: {
    AuditList,
  },
  computed: {
    ...mapState("kycAudit", ["activeTab", "pagination"]),
    startDate() {
      return this.times && this.times[0]
        ? new Date(new Date(this.times[0]).setHours(0, 0, 0, 0)).getTime()
        : "";
    },
    endDate() {
      return this.times && this.times[1]
        ? new Date(new Date(this.times[1]).setHours(23, 59, 59, 999)).getTime()
        : "";
    },
    downloadLink() {
      const data = {
        type: 0,
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab,
        ...PAGINATION,
      };
      const params = qs.stringify(data);
      return `/la/admin/authRecord/export?${params}`;
    },
  },
  methods: {
    ...mapActions("kycAudit", ["list", "getExcel", "getIdOK"]),
    //模板下载

    handleTabChange(tab) {
      this.userId = null;
      this.types = tab.name;
      this.tenantId = "";
      this.statusType = "";
      this.realName = "";
      if (tab.name == "hight") {
        this.authType = "1";
        this.types = null;
      } else {
        this.authType = "0";
      }
      this.list({ status: this.types, authType: this.authType, ...PAGINATION });
    },
    handleSearch() {
      // if (this.types != 1) {
      this.list({
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab == "hight" ? null : this.activeTab,
        authType: this.authType,
        ...PAGINATION,
        tenantId: this.tenantId,
      });
      this.activeTab == "hight" && (this.types = null);
      // } else {
      //   this.getIdOK({
      //     startDate: this.startDate,
      //     endDate: this.endDate,
      //     userId: this.userId,
      //     tel: this.tel,
      //     status: this.activeTab,
      //     ...PAGINATION,
      //     tenantId: this.tenantId,
      //   });
      // }
    },
    refreshList(data = {}) {
      // if (this.types != 1) {
      this.list({
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab == "hight" ? null : this.activeTab,
        authType: this.authType,
        ...this.pagination,
        ...data,
      });
      this.activeTab == "hight" && (this.types = null);
      // } else {
      //   this.getIdOK({
      //     status: this.activeTab,
      //     userId: this.userId,
      //     tel: this.tel,
      //     email: this.email,
      //     ...this.pagination,
      //     tenantId: this.tenantId,
      //     ...data,
      //   });
      // }
    },
    exportExcel() {
      this.getExcel({
        type: 0,
        startDate: this.startDate,
        endDate: this.endDate,
        userId: this.userId,
        statusType: this.statusType,
        realName: this.realName,
        tel: this.tel,
        status: this.activeTab,
        tenantId: this.tenantId,
        ...PAGINATION,
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
        console.log("link-href", link.href);
        link.download = "KYC认证统计报表";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
      });
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.list({ status: 0, authType: this.authType, page: 1, size: 25 });
  },
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
  .el-input {
    width: 300px;
    margin-right: 10px;
  }
  .el-button {
    margin-left: 10px;
  }
}
a {
  font-size: 13px;
  margin-left: 10px;
}
</style>
